import type { FC, ReactNode } from 'react'

import type { WhiteLabel } from '@skytech/types'

import './styles.scss'

type IconSize = 'xs' | 'small' | 'medium' | 'large'
type ColoMode = 'success' | 'white' | 'info'

export const Icon: FC<{
  children: ReactNode
  className?: string
  isWhiteLabeled?: boolean
  size?: IconSize
  block?: boolean
  colorMode?: ColoMode
  'data-tooltip-id'?: string
  'data-tooltip-content'?: string
  whiteLabel?: WhiteLabel
}> = ({
  className = '',
  colorMode,
  isWhiteLabeled = true,
  children,
  size = 'medium',
  block,
  whiteLabel: _whiteLabel,
  ...rest
}) => {
  // todo: replace with the org from url when ready
  const storedWhiteLabel = localStorage.getItem('org') as WhiteLabel
  const whiteLabel = _whiteLabel || storedWhiteLabel || 'control'

  return (
    <span
      className={`ui-icon ${className} ${isWhiteLabeled ? whiteLabel : ''} ${size} ${
        block ? 'block' : ''
      } ${colorMode || ''}`}
      {...rest}
    >
      {children}
    </span>
  )
}
